import { useEffect, useState } from 'react';
import Comment from './Comentario';
import { ButtonSiguiente } from '../../../ui';
import { ComentarioData, CommentListProps } from '@/types';
//ruta para el fech
import { safeFetch } from '@/api/safeFetch';



const CommentList: React.FC<CommentListProps> = ({ perfil_id, servicio_name, profesional_name, className }) => {
  // 📦 Estados para los comentarios
  const [comentarios, setComentarios] = useState<ComentarioData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // 👀 Control de comentarios visibles (paginación simple)
  const [visibleComments, setVisibleComments] = useState<number>(3);

  useEffect(() => {
    const fetchComentarios = async () => {
      try {
        // 🟢 Llamada a la API usando variable de entorno
        const response = await safeFetch(`/api/profesional/${servicio_name}/${profesional_name}/${perfil_id}/comentarios`);
        if (!response.ok) {
          throw new Error('Error al cargar los comentarios');
        }
        const data: ComentarioData[] = await response.json();

      

        // ✅ Aseguramos que `data` sea un array
        if (Array.isArray(data)) {
          setComentarios(data);
        } else {
          setComentarios([]);
          console.warn('Se esperaba un array de comentarios, pero no se recibió uno.');
        }
      } catch (error: unknown) {
        setError((error as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchComentarios();
  }, [perfil_id, servicio_name, profesional_name]); // 🔁 Dependencias correctas

  // ⏳ Estados de carga y error
  if (loading) return <div>Cargando comentarios...</div>;
  if (error) return <div>Error: {error}</div>;

  // 🔄 Invertimos el orden de los comentarios (últimos primero)
  const reversedComentarios = comentarios.slice().reverse();

  // 👆 Mostrar más comentarios al pulsar botón
  const handleShowMore = () => {
    setVisibleComments((prevVisibleComments) => prevVisibleComments + 3); // Incrementa 3 más
  };

  return (
    <div className={`${className}`}>
      <h2 className="text-2xl font-semibold text-zinc-900 mb-4 text-center">Comentarios</h2>
      
      {reversedComentarios.length > 0 ? (
        <>
          {reversedComentarios.slice(0, visibleComments).map((comentario) => (
            <Comment
              key={comentario.comentario_id}
              comentario_id={comentario.comentario_id} // ✅ Mantener prop de ID
              comentario={comentario.comentario}
              puntuacion={comentario.puntuacion}
              creado_en={comentario.creado_en}
              usuario={comentario.nombre_usuario ?? 'Anónimo'}
            />
          ))}

          {/* 🔽 Botón para mostrar más comentarios */}
          {visibleComments < reversedComentarios.length && (
            <div className="flex justify-center mt-4">
              <ButtonSiguiente
                className='xs:w-3/6 sm:w-2/6 md:w-1/6'
                onClick={handleShowMore}
              >
                Mostrar más
              </ButtonSiguiente>
            </div>
          )}
        </>
      ) : (
        // 📭 Mensaje si no hay comentarios
        <p className="text-center font-semibold text-zinc-900">Aún no hay comentarios.</p>
      )}
    </div>
  );
};

export default CommentList;
